import classNames from "classnames";
import React from "react";

import { ErrorIcon, LoadingIcon } from "~/ui/components/icons";

export interface BoundaryProps {
  isError?: boolean;
  isLoading?: boolean;
  centerStatus?: boolean;
  children: React.ReactNode;
  className?: string;
  iconClassname?: string;
}

const IconWrapper: React.FC<{ className?: string }> = ({
  children,
  className,
}) => (
  <div
    className={classNames(
      "w-100 flex items-center justify-center pd-t-lg pd-b-lg",
      className
    )}
  >
    {children}
  </div>
);

export function Boundary(props: BoundaryProps) {
  const {
    isError,
    isLoading,
    children,
    centerStatus,
    className,
    iconClassname,
  } = props;
  if (isError) {
    return (
      <IconWrapper className={className}>
        <ErrorIcon
          center={centerStatus}
          className={classNames(iconClassname ? iconClassname : "text-white")}
        />
      </IconWrapper>
    );
  }
  if (isLoading) {
    return (
      <IconWrapper className={className}>
        <LoadingIcon
          center={centerStatus}
          className={classNames(iconClassname ? iconClassname : "text-white")}
        />
      </IconWrapper>
    );
  }
  return <>{children}</>;
}
